import React from 'react';
import { useNavigate } from 'react-router-dom';

const PrivacyPolicyPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-950 text-amber-50 p-6">
      <div className="max-w-3xl mx-auto">
        <div className="flex items-center gap-4 mb-8">
          <button
            onClick={() => navigate(-1)}
            className="bg-slate-800/60 border border-white/10 hover:border-amber-500/30 text-amber-50 px-4 py-2 rounded-full transition-all text-sm"
          >
            ← Retour
          </button>
          <h1 className="text-2xl font-bold text-amber-400">Politique de confidentialité</h1>
        </div>

        <div className="bg-slate-800/60 border border-white/10 rounded-2xl p-6 space-y-6 text-slate-300 leading-relaxed">

          <p className="text-slate-400 text-sm">Dernière mise à jour : mars 2026</p>

          <section>
            <h2 className="text-lg font-semibold text-amber-300 mb-2">1. Responsable du traitement</h2>
            <p>
              Le responsable du traitement des données personnelles collectées via cette application est :<br />
              <strong className="text-amber-50">Cyril Tronchet</strong><br />
              Contact : <a href="mailto:musicjob1975@gmail.com" className="text-amber-400 hover:underline">musicjob1975@gmail.com</a>
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-amber-300 mb-2">2. Données collectées</h2>
            <p>L'application collecte les données suivantes :</p>
            <ul className="list-disc list-inside mt-2 space-y-1">
              <li>Adresse e-mail (lors de la création de compte)</li>
              <li>Pseudo choisi par l'utilisateur</li>
              <li>Données de progression pédagogique (exercices complétés, scores, XP)</li>
              <li>Données de connexion (date de dernière connexion)</li>
              <li>Configuration MIDI (latence, vélocité minimale)</li>
            </ul>
            <p className="mt-2">
              Les comptes anonymes (mode "Découvrir") ne nécessitent pas d'e-mail. Seul un identifiant technique anonyme est créé.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-amber-300 mb-2">3. Finalités du traitement</h2>
            <p>Les données sont collectées pour :</p>
            <ul className="list-disc list-inside mt-2 space-y-1">
              <li>Permettre la connexion et l'authentification</li>
              <li>Sauvegarder et synchroniser votre progression pédagogique</li>
              <li>Afficher les classements et statistiques</li>
              <li>Permettre au professeur de suivre la progression de ses élèves</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-amber-300 mb-2">4. Base légale</h2>
            <p>
              Le traitement est fondé sur l'exécution du contrat (fourniture du service d'apprentissage) et, pour les mineurs, sur le consentement parental conformément à l'article 8 du RGPD.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-amber-300 mb-2">5. Hébergement et transfert de données</h2>
            <p>
              Les données sont hébergées sur <strong className="text-amber-50">Firebase (Google LLC)</strong>, via les services Firestore, Firebase Authentication et Firebase Storage.
              Google LLC est établie aux États-Unis. Ce transfert est encadré par les Clauses Contractuelles Types (CCT) approuvées par la Commission européenne, conformément à l'article 46 du RGPD.
            </p>
            <p className="mt-2">
              Pour plus d'informations : <a href="https://firebase.google.com/support/privacy" target="_blank" rel="noreferrer" className="text-amber-400 hover:underline">Politique de confidentialité Firebase</a>
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-amber-300 mb-2">6. Durée de conservation</h2>
            <p>
              Les données sont conservées pendant toute la durée d'utilisation du compte. En cas de suppression du compte (via Paramètres → Supprimer mon compte), l'ensemble des données personnelles est supprimé dans un délai immédiat.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-amber-300 mb-2">7. Vos droits</h2>
            <p>Conformément au RGPD, vous disposez des droits suivants :</p>
            <ul className="list-disc list-inside mt-2 space-y-1">
              <li><strong className="text-amber-50">Droit d'accès</strong> : obtenir une copie de vos données</li>
              <li><strong className="text-amber-50">Droit de rectification</strong> : corriger vos données inexactes</li>
              <li><strong className="text-amber-50">Droit à l'effacement</strong> : supprimer votre compte directement depuis Paramètres</li>
              <li><strong className="text-amber-50">Droit à la portabilité</strong> : recevoir vos données dans un format lisible</li>
              <li><strong className="text-amber-50">Droit d'opposition</strong> : vous opposer à certains traitements</li>
            </ul>
            <p className="mt-2">
              Pour exercer vos droits, contactez : <a href="mailto:musicjob1975@gmail.com" className="text-amber-400 hover:underline">musicjob1975@gmail.com</a>
            </p>
            <p className="mt-2">
              Vous pouvez également adresser une réclamation à la <strong className="text-amber-50">CNIL</strong> : <a href="https://www.cnil.fr" target="_blank" rel="noreferrer" className="text-amber-400 hover:underline">www.cnil.fr</a>
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-amber-300 mb-2">8. Cookies et traceurs</h2>
            <p>
              Cette application n'utilise <strong className="text-amber-50">aucun cookie de tracking ou publicitaire</strong>. Seul le localStorage et sessionStorage du navigateur sont utilisés pour le fonctionnement technique de l'application (session utilisateur, paramètres locaux). Aucun bandeau de consentement aux cookies n'est requis.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-amber-300 mb-2">9. Mineurs</h2>
            <p>
              Lors de la création d'un compte élève, l'utilisateur certifie avoir 15 ans ou plus, ou disposer du consentement parental. Les données des mineurs bénéficient des mêmes droits et protections.
            </p>
          </section>

        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
